/** Live checkout destination for every buy button on the page. */
export const CHECKOUT_URL = 'https://jazz-master-pl.impultienda.ar/checkout'
